<form [formGroup]="form">
    <ham-accordion>
        <ham-accordion-item
            (opened)="onToggleComponentsAccordion()"
            (closed)="onToggleComponentsAccordion()"
            [isOpened]="openedPrintOptionsAccordions?.componentsAccordion"
            #componentsAccordion
        >
            <div accordion-header>
                <span class="accordion-header-content">
                    <span
                        hamIconShapes
                        class="accordion-header-icon"
                        icon="assets/hamIcons/grid-outline.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    >
                    </span>
                    <span> {{ 'aumico_annual_report_print_options_components_accordion_title' | i18next }} </span>
                </span>
                <span class="accordion-icon">
                    <span
                        *ngIf="!isComponentsAccordionExpanded"
                        class="chevron-down"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-down.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                        (click)="componentsAccordion.onToggle()"
                    ></span>
                    <span
                        *ngIf="isComponentsAccordionExpanded"
                        hamIconShapes
                        class="chevron-up-outline"
                        icon="assets/hamIcons/chevron-up-outline.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                        (click)="componentsAccordion.onToggle()"
                    ></span>
                </span>
            </div>
            <div accordion-body>
                <div class="accordion-content" *ngIf="printOptionsVisibility.displayOptions.hasCoverSheetToggle">
                    <span class="cover-title">
                        {{ 'aumico_annual_report_print_options_show_cover_sheet' | i18next }}
                    </span>
                    <ham-toggle [formControlValue]="form.get('displayOptions')['controls']['showCoverSheet']">
                    </ham-toggle>
                </div>
                <div class="accordion-content">
                    <span>
                        {{ 'aumico_annual_report_print_options_show_company_logo' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showReportCompanyLogo']"
                        ></ham-toggle>
                    </span>
                </div>
                <div
                    class="accordion-content"
                    *ngIf="
                        printOptionsVisibility.displayOptions.hasUIDonCoverToggle &&
                        form.get('displayOptions')['controls']['showCoverSheet'].value
                    "
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_uid' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showUIDonCover']"
                        ></ham-toggle>
                    </span>
                </div>

                <div
                    class="accordion-content"
                    *ngIf="
                        printOptionsVisibility.displayOptions.hasCompanyLogoToggle &&
                        form.get('displayOptions')['controls']['showCoverSheet'].value
                    "
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_organization_logo' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showCompanyLogo']"
                        ></ham-toggle>
                    </span>
                </div>

                <div
                    class="accordion-content"
                    *ngIf="
                        printOptionsVisibility.displayOptions.hasCompanyInfosToggle &&
                        form.get('displayOptions')['controls']['showCoverSheet'].value
                    "
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_company_info' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showCompanyInfos']"
                        ></ham-toggle>
                    </span>
                </div>

                <div class="accordion-content" *ngIf="form.value.displayOptions.showCoverSheet">
                    <span> {{ 'aumico_annual_report_print_options_mainTitle' | i18next }} </span>
                    <span>
                        <input
                            hamInput
                            [formControl]="form.get('displayOptions')['controls']['mainTitle']"
                            placeholder="{{ 'aumico_annual_report_print_options_mainTitle' | i18next }}"
                        />
                    </span>
                </div>
                <div class="accordion-content" *ngIf="form.value.displayOptions.showCoverSheet">
                    <span> {{ 'aumico_annual_report_print_options_subTitle' | i18next }} </span>
                    <span>
                        <input
                            hamInput
                            [formControl]="form.get('displayOptions')['controls']['subtitle']"
                            placeholder="{{ 'aumico_annual_report_print_options_subTitle' | i18next }}"
                        />
                    </span>
                </div>
                <div class="accordion-content" *ngIf="form.value.displayOptions.showCoverSheet">
                    <span> {{ 'aumico_annual_report_print_options_date' | i18next }} </span>
                    <span>
                        <input
                            hamInput
                            [formControl]="form.get('displayOptions')['controls']['dateTitle']"
                            placeholder="{{ 'aumico_annual_report_print_options_date' | i18next }}"
                        />
                    </span>
                </div>

                <div class="horizontal-separator"></div>

                <div class="accordion-content" *ngIf="printOptionsVisibility.displayOptions.hasTableOfContentsToggle">
                    <span>
                        {{ 'aumico_annual_report_print_options_show_table_of_contents' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showTableOfContents']"
                        ></ham-toggle>
                    </span>
                </div>

                <div
                    class="accordion-content left-space"
                    *ngIf="
                        printOptionsVisibility.displayOptions.hasTableOfContentsToggle &&
                        form.value.displayOptions.showTableOfContents
                    "
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_notes_in_detail_in_toc' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showNotesInDetailInToc']"
                        ></ham-toggle>
                    </span>
                </div>

                <div class="accordion-content" *ngIf="printOptionsVisibility.displayOptions.hasCfsToggle">
                    <span>
                        {{ 'aumico_annual_report_print_options_show_cfs' | i18next }}
                    </span>
                    <span>
                        <ham-toggle [formControlValue]="form.get('displayOptions')['controls']['showCfs']"></ham-toggle>
                    </span>
                </div>

                <div class="accordion-content" *ngIf="printOptionsVisibility.displayOptions.hasNotesToggle">
                    <span>
                        {{ 'aumico_annual_report_print_options_show_notes' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showNotes']"
                        ></ham-toggle>
                    </span>
                </div>

                <div class="accordion-content" *ngIf="printOptionsVisibility.displayOptions.hasAopToggle">
                    <span>
                        {{ 'aumico_annual_report_print_options_show_aop' | i18next }}
                    </span>
                    <span>
                        <ham-toggle [formControlValue]="form.get('displayOptions')['controls']['showAop']"></ham-toggle>
                    </span>
                </div>

                <div
                    class="accordion-content"
                    *ngIf="printOptionsVisibility.displayOptions.hasComplementaryReportsToggle"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_complementary_reports' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showComplementaryReports']"
                            (changed)="onShowComplementaryReportsToggleChanged($event)"
                        ></ham-toggle>
                    </span>
                </div>

                <div
                    class="complementary-reports-list"
                    *ngIf="
                        printOptionsVisibility.displayOptions.hasComplementaryReportsToggle &&
                        complementaryReports.length
                    "
                >
                    <div
                        class="complementary-report-item"
                        *ngFor="let report of complementaryReports; let index = index"
                    >
                        <span class="complementary-report-title">{{ report.title }}</span>
                        <span class="complementary-report-actions">
                            <ham-button
                                variant="white"
                                outline="true"
                                size="xs"
                                (buttonClick)="onPrintComplementaryReport(index)"
                            >
                                {{ 'aumico_annual_report_print_options_print' | i18next }}
                            </ham-button>
                            <ham-toggle
                                [checked]="isComplementaryReportSelected(index)"
                                [disabled]="!form.value.displayOptions.showComplementaryReports"
                                (changed)="onComplementaryReportToggleChanged(index, $event)"
                            ></ham-toggle>
                        </span>
                    </div>
                </div>

                <div
                    class="accordion-content"
                    *ngIf="printOptionsVisibility.displayOptions.hasAccountProofForBalanceToggle"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_balance_account_proof' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showAccountProofForBalance']"
                        ></ham-toggle>
                    </span>
                </div>

                <div
                    class="accordion-content"
                    *ngIf="printOptionsVisibility.displayOptions.hasAccountProofForIncomeToggle"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_income_account_proof' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showAccountProofForIncome']"
                        ></ham-toggle>
                    </span>
                </div>

                <div class="accordion-content" *ngIf="printOptionsVisibility.displayOptions.hasEmsToggle">
                    <span>
                        {{ 'aumico_annual_report_print_options_show_ems' | i18next }}
                    </span>
                    <span>
                        <ham-toggle [formControlValue]="form.get('displayOptions')['controls']['showEms']"></ham-toggle>
                    </span>
                </div>

                <div class="accordion-content last-item" *ngIf="printOptionsVisibility.displayOptions.hasFasToggle">
                    <span>
                        {{ 'aumico_annual_report_print_options_show_fas' | i18next }}
                    </span>
                    <span>
                        <ham-toggle [formControlValue]="form.get('displayOptions')['controls']['showFas']"></ham-toggle>
                    </span>
                </div>
            </div>
        </ham-accordion-item>
    </ham-accordion>

    <ham-accordion>
        <ham-accordion-item
            (opened)="onToggleSettingsAccordion()"
            (closed)="onToggleSettingsAccordion()"
            [isOpened]="openedPrintOptionsAccordions?.settingsAccordion"
            #settingsAccordion
        >
            <div accordion-header>
                <span class="accordion-header-content">
                    <span
                        hamIconShapes
                        class="accordion-header-icon"
                        icon="assets/hamIcons/settings-wheel.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    >
                    </span>
                    <span> {{ 'aumico_annual_report_print_options_settings_accordion_title' | i18next }} </span>
                </span>
                <span class="accordion-icon">
                    <span
                        *ngIf="!isSettingsAccordionExpanded"
                        class="chevron-down"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-down.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                        (click)="settingsAccordion.onToggle()"
                    ></span>
                    <span
                        *ngIf="isSettingsAccordionExpanded"
                        hamIconShapes
                        class="chevron-up-outline"
                        icon="assets/hamIcons/chevron-up-outline.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                        (click)="settingsAccordion.onToggle()"
                    ></span>
                </span>
            </div>
            <div accordion-body>
                <div class="title">{{ 'aumico_annual_report_print_options_general_accordion_title' | i18next }}</div>

                <div
                    class="accordion-content"
                    *ngIf="printOptionsVisibility.displayOptions.hasDisableBalanceSheetPageBreakToggle"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_disable_balance_sheet_page_break' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['disableBalanceSheetPageBreak']"
                        ></ham-toggle>
                    </span>
                </div>
                <div class="accordion-content ratios" *ngIf="printOptionsVisibility.displayOptions.hasRatiosToggle">
                    <span>
                        {{ 'aumico_annual_report_print_options_label_show_ratios' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showRatios']"
                            [disabled]="fxStatementColumnsOn"
                        ></ham-toggle>
                    </span>
                </div>
                <div class="accordion-content" *ngIf="form.value.displayOptions.showRatios">
                    <span></span>
                    <span>
                        <aum-select
                            [hidden]="
                                !printOptionsVisibility.displayOptions.hasRatiosToggle ||
                                !form.value.displayOptions.showRatios
                            "
                            [aumFormControl]="selectedIncomeItemForCalculatingRatioFormControl"
                            [options]="incomeItemsSelectionsForCalculatingRatio"
                            [propertyOfOptionId]="'name'"
                            [propertyOfOptionToDisplay]="'caption'"
                            [compareWith]="compareIncomeItemForCalculatingRatio"
                        >
                        </aum-select>
                    </span>
                </div>
                <div
                    class="accordion-content empty"
                    *ngIf="printOptionsVisibility.displayOptions.hasHideEmptyLinesToggle"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_empty_lines' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showEmptyLines']"
                        ></ham-toggle>
                    </span>
                </div>
                <div class="accordion-content" *ngIf="printOptionsVisibility.displayOptions.hasHidePreviousYearToggle">
                    <span>
                        {{ 'aumico_annual_report_print_options_hide_previous_year' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['hidePreviousYear']"
                        ></ham-toggle>
                    </span>
                </div>
                <div
                    class="accordion-content"
                    *ngIf="printOptionsVisibility.displayOptions.hasAccountsToggle"
                    [ngClass]="{ 'less-margin-below': form.value.displayOptions.showAccounts }"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_accounts' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showAccounts']"
                        ></ham-toggle>
                    </span>
                </div>
                <div
                    class="accordion-content left-space less-margin-below"
                    *ngIf="
                        printOptionsVisibility.displayOptions.hasAccountNumbersToggle &&
                        form.value.displayOptions.showAccounts
                    "
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_account_numbers' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showAccountNumbers']"
                        ></ham-toggle>
                    </span>
                </div>
                <div
                    class="accordion-content left-space"
                    *ngIf="
                        printOptionsVisibility.displayOptions.hasFliTotalToggle &&
                        form.value.displayOptions.showAccounts
                    "
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_show_fli_total' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showFliTotal']"
                        ></ham-toggle>
                    </span>
                </div>
                <!-- REV-20899: Reclassifications are now always included in totals (transactional model). Toggle removed. -->
                <div class="accordion-content" *ngIf="printOptionsVisibility.displayOptions.hasAdjustmentInSumsToggle">
                    <span>
                        {{ 'aumico_annual_report_print_options_label_show_adjustments_in_sums' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['showAdjustmentInSums']"
                        ></ham-toggle>
                    </span>
                </div>
                <div class="horizontal-separator"></div>
                <div class="title">
                    {{ 'aumico_annual_report_print_options_financial_statement_components_title' | i18next }}
                </div>
                <div
                    class="accordion-content"
                    *ngIf="printOptionsVisibility.displayOptions.hasFinStatementHideDecimalPlacesValuesToggle"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_hide_decimal_places_in_values' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="
                                form.get('displayOptions')['controls']['finStatementHideDecimalPlacesValues']
                            "
                        ></ham-toggle>
                    </span>
                </div>
                <div
                    class="accordion-content"
                    *ngIf="printOptionsVisibility.displayOptions.hasFinStatementRoundToThousandsToggle"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_round_to_thousands' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['finStatementRoundToThousands']"
                        ></ham-toggle>
                    </span>
                </div>
                <div
                    class="accordion-content"
                    *ngIf="printOptionsVisibility.displayOptions.hasFinStatementHideDecimalPlacesRatiosToggle"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_hide_decimal_places_in_ratios' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="
                                form.get('displayOptions')['controls']['finStatementHideDecimalPlacesRatios']
                            "
                        ></ham-toggle>
                    </span>
                </div>
                <div
                    class="accordion-content"
                    *ngIf="printOptionsVisibility.displayOptions.hasFinStatementHideEmptyLinesToggle"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_hide_empty_lines' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['finStatementHideEmptyLines']"
                        ></ham-toggle>
                    </span>
                </div>
                <div *ngIf="printOptionsVisibility.displayOptions.hasNotesToggle">
                    <div class="horizontal-separator"></div>
                    <div class="title">{{ 'aumico_annual_report_print_options_notes_component_title' | i18next }}</div>
                    <div
                        class="accordion-content"
                        *ngIf="printOptionsVisibility.displayOptions.hasNotesHideDecimalPlacesValuesToggle"
                    >
                        <span>
                            {{ 'aumico_annual_report_print_options_hide_decimal_places_in_values' | i18next }}
                        </span>
                        <span>
                            <ham-toggle
                                [formControlValue]="
                                    form.get('displayOptions')['controls']['notesHideDecimalPlacesValues']
                                "
                            ></ham-toggle>
                        </span>
                    </div>
                    <div
                        class="accordion-content"
                        *ngIf="printOptionsVisibility.displayOptions.hasNotesRoundToThousandsToggle"
                    >
                        <span>
                            {{ 'aumico_annual_report_print_options_round_to_thousands' | i18next }}
                        </span>
                        <span>
                            <ham-toggle
                                [formControlValue]="form.get('displayOptions')['controls']['notesRoundToThousands']"
                            ></ham-toggle>
                        </span>
                    </div>
                    <div
                        class="accordion-content"
                        *ngIf="printOptionsVisibility.displayOptions.hasNotesHideEmptyLinesToggle"
                    >
                        <span>
                            {{ 'aumico_annual_report_print_options_hide_empty_lines' | i18next }}
                        </span>
                        <span>
                            <ham-toggle
                                [formControlValue]="form.get('displayOptions')['controls']['notesHideEmptyLines']"
                            ></ham-toggle>
                        </span>
                    </div>
                    <div
                        class="accordion-content"
                        *ngIf="printOptionsVisibility.displayOptions.hasRepeatAppendixTitleToggle"
                    >
                        <span>
                            {{ 'aumico_annual_report_print_options_repeat_appendix_title' | i18next }}
                        </span>
                        <span>
                            <ham-toggle
                                [formControlValue]="form.get('displayOptions')['controls']['repeatAppendixTitle']"
                            ></ham-toggle>
                        </span>
                    </div>
                </div>
                <div *ngIf="printOptionsVisibility.displayOptions.hasAopToggle">
                    <div class="horizontal-separator"></div>
                    <div class="title">{{ 'aumico_annual_report_print_options_aop_component_title' | i18next }}</div>
                    <div
                        class="accordion-content"
                        *ngIf="printOptionsVisibility.displayOptions.hasAopHideDecimalPlacesValuesToggle"
                    >
                        <span>
                            {{ 'aumico_annual_report_print_options_hide_decimal_places_in_values' | i18next }}
                        </span>
                        <span>
                            <ham-toggle
                                [formControlValue]="
                                    form.get('displayOptions')['controls']['aopHideDecimalPlacesValues']
                                "
                            ></ham-toggle>
                        </span>
                    </div>
                    <div
                        class="accordion-content"
                        *ngIf="printOptionsVisibility.displayOptions.hasAopRoundToThousandsToggle"
                    >
                        <span>
                            {{ 'aumico_annual_report_print_options_round_to_thousands' | i18next }}
                        </span>
                        <span>
                            <ham-toggle
                                [formControlValue]="form.get('displayOptions')['controls']['aopRoundToThousands']"
                            ></ham-toggle>
                        </span>
                    </div>
                    <div
                        class="accordion-content"
                        *ngIf="printOptionsVisibility.displayOptions.hasAopHideEmptyLinesToggle"
                    >
                        <span>
                            {{ 'aumico_annual_report_print_options_hide_empty_lines' | i18next }}
                        </span>
                        <span>
                            <ham-toggle
                                [formControlValue]="form.get('displayOptions')['controls']['aopHideEmptyLines']"
                            ></ham-toggle>
                        </span>
                    </div>
                </div>
                <div class="horizontal-separator"></div>
                <div class="title">{{ 'aumico_annual_report_print_options_advanced_title' | i18next }}</div>
                <div
                    class="accordion-content last-item"
                    *ngIf="printOptionsVisibility.displayOptions.hasNonBreakingHyphenToggle"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_label_non_breaking_hyphen_toggle' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['nonBreakingHyphen']"
                        ></ham-toggle>
                    </span>
                </div>
            </div>
        </ham-accordion-item>
    </ham-accordion>

    <!-- FX (REV-21512): Functional-Currency reports only -->
    <ham-accordion *ngIf="fxEnabled">
        <ham-accordion-item
            (opened)="onToggleFxAccordion()"
            (closed)="onToggleFxAccordion()"
            [isOpened]="openedPrintOptionsAccordions?.fxAccordion === true"
            #fxAccordion
        >
            <div accordion-header>
                <span class="accordion-header-content">
                    <span
                        hamIconShapes
                        class="accordion-header-icon"
                        icon="assets/hamIcons/arrows-repeat.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    >
                    </span>
                    <span> {{ 'aumico_annual_report_print_options_fx_accordion_title' | i18next }} </span>
                </span>
                <span class="accordion-icon">
                    <span
                        *ngIf="!isFxAccordionExpanded"
                        class="chevron-down"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-down.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                        (click)="fxAccordion.onToggle()"
                    ></span>
                    <span
                        *ngIf="isFxAccordionExpanded"
                        hamIconShapes
                        class="chevron-up-outline"
                        icon="assets/hamIcons/chevron-up-outline.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                        (click)="fxAccordion.onToggle()"
                    ></span>
                </span>
            </div>
            <div accordion-body>
                <div class="accordion-content">
                    <span>
                        {{ 'aumico_annual_report_print_options_fx_show_statement_display_columns' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('displayOptions')['controls']['fxShowStatementDisplayColumns']"
                        ></ham-toggle>
                    </span>
                </div>
            </div>
        </ham-accordion-item>
    </ham-accordion>

    <ham-accordion>
        <ham-accordion-item
            (opened)="onToggleSignatureAccordion()"
            (closed)="onToggleSignatureAccordion()"
            [isOpened]="openedPrintOptionsAccordions?.signatureAccordion"
            #signatureAccordion
        >
            <div accordion-header>
                <span class="accordion-header-content">
                    <span
                        hamIconShapes
                        class="accordion-header-icon"
                        icon="assets/hamIcons/pen-nib-outline.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    >
                    </span>
                    <span> {{ 'aumico_annual_report_print_options_signature_accordion_title' | i18next }} </span>
                </span>
                <span class="accordion-icon">
                    <span
                        *ngIf="!isSignatureAccordionExpanded"
                        class="chevron-down"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-down.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                        (click)="signatureAccordion.onToggle()"
                    ></span>
                    <span
                        *ngIf="isSignatureAccordionExpanded"
                        hamIconShapes
                        class="chevron-up-outline"
                        icon="assets/hamIcons/chevron-up-outline.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                        (click)="signatureAccordion.onToggle()"
                    ></span>
                </span>
            </div>
            <div accordion-body>
                <div class="accordion-content" *ngIf="printOptionsVisibility.signatureOptions.placeSignatureAfterAop">
                    <label class="radio-label-container">
                        <span>
                            {{ 'aumico_annual_report_print_options_place_signature_after_income_statement' | i18next }}
                        </span>
                        <span
                            hamRadio
                            [formControl]="form.get('signatureOptions')['controls']['placeSignatureAfterAop']"
                            [value]="false"
                        >
                        </span>
                    </label>
                </div>
                <div class="accordion-content" *ngIf="printOptionsVisibility.signatureOptions.placeSignatureAfterAop">
                    <label class="radio-label-container">
                        <span>
                            {{ 'aumico_annual_report_print_options_place_signature_after_aop' | i18next }}
                        </span>
                        <span
                            hamRadio
                            [formControl]="form.get('signatureOptions')['controls']['placeSignatureAfterAop']"
                            [value]="true"
                        >
                        </span>
                    </label>
                </div>
                <div
                    class="horizontal-separator"
                    *ngIf="printOptionsVisibility.signatureOptions.placeSignatureAfterAop"
                ></div>
                <div class="accordion-content" *ngIf="printOptionsVisibility.signatureOptions.hasSignature">
                    <span>
                        {{ 'aumico_annual_report_print_options_place_of_signing' | i18next }}
                    </span>
                    <span>
                        <input
                            hamInput
                            [formControl]="form.get('signatureOptions')['controls']['place']"
                            placeholder="{{ 'aumico_annual_report_print_options_place_of_signing' | i18next }}"
                        />
                    </span>
                </div>
                <div class="accordion-content" *ngIf="printOptionsVisibility.signatureOptions.hasSignature">
                    <span>
                        {{ 'aumico_annual_report_print_options_date_of_signing' | i18next }}
                    </span>
                    <span>
                        <input
                            hamInput
                            [formControl]="form.get('signatureOptions')['controls']['date']"
                            placeholder="{{ 'aumico_annual_report_print_options_date_of_signing' | i18next }}"
                        />
                    </span>
                </div>
                <div class="accordion-content" *ngIf="printOptionsVisibility.signatureOptions.hasSignature">
                    <span>
                        {{ 'aumico_annual_report_print_options_signature' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('signatureOptions')['controls']['hasSignature']"
                        ></ham-toggle>
                    </span>
                </div>
                <div
                    class="accordion-content less-margin-below"
                    *ngIf="printOptionsVisibility.signatureOptions.isCollectiveSignature"
                >
                    <span>
                        {{ 'aumico_annual_report_print_options_collective_signature' | i18next }}
                    </span>
                    <span>
                        <ham-toggle
                            [formControlValue]="form.get('signatureOptions')['controls']['isCollectiveSignature']"
                        ></ham-toggle>
                    </span>
                </div>
                <div
                    class="accordion-content less-margin-below"
                    *ngIf="
                        printOptionsVisibility.signatureOptions.hasSignature && form.value.signatureOptions.hasSignature
                    "
                >
                    <span class="left-space"> {{ 'aumico_annual_report_print_options_signatory_1' | i18next }} </span>
                    <span class="signature-input">
                        <input
                            hamInput
                            [formControl]="form.get('signatureOptions')['controls']['signature1']"
                            placeholder="{{ 'aumico_annual_report_print_options_signatory_1' | i18next }}"
                        />
                    </span>
                </div>
                <div
                    class="accordion-content last-item"
                    *ngIf="
                        printOptionsVisibility.signatureOptions.isCollectiveSignature &&
                        form.value.signatureOptions.isCollectiveSignature &&
                        printOptionsVisibility.signatureOptions.hasSignature &&
                        form.value.signatureOptions.hasSignature
                    "
                >
                    <span class="left-space">
                        {{ 'aumico_annual_report_print_options_signatory_2' | i18next }}
                    </span>
                    <span class="signature-input">
                        <input
                            hamInput
                            [formControl]="form.get('signatureOptions')['controls']['signature2']"
                            placeholder="{{ 'aumico_annual_report_print_options_signatory_2' | i18next }}"
                        />
                    </span>
                </div>
            </div>
        </ham-accordion-item>
    </ham-accordion>

    <ham-accordion>
        <ham-accordion-item
            (opened)="onToggleColorsAccordion()"
            (closed)="onToggleColorsAccordion()"
            [isOpened]="openedPrintOptionsAccordions?.colorsAccordion"
            #colorsAccordion
        >
            <div accordion-header>
                <span class="accordion-header-content">
                    <span
                        hamIconShapes
                        class="accordion-header-icon"
                        icon="assets/hamIcons/palette-outline.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                    >
                    </span>
                    <span> {{ 'aumico_annual_report_print_options_colors_accordion_title' | i18next }} </span>
                </span>
                <span class="accordion-icon">
                    <span
                        *ngIf="!isColorsAccordionExpanded"
                        class="chevron-down"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-down.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                        (click)="colorsAccordion.onToggle()"
                    ></span>
                    <span
                        *ngIf="isColorsAccordionExpanded"
                        hamIconShapes
                        class="chevron-up-outline"
                        icon="assets/hamIcons/chevron-up-outline.svg"
                        [variant]="'transparent'"
                        [size]="'regular'"
                        (click)="colorsAccordion.onToggle()"
                    ></span>
                </span>
            </div>
            <div accordion-body>
                <div class="colorsPickers">
                    <span class="color-box">
                        <label for="textColor">{{ 'aumico_reports_print_text_color' | i18next }}</label>
                        <input
                            type="color"
                            [formControl]="form.get('styleOptions')['controls']['textColor']"
                            name="textColor"
                        />
                    </span>
                    <span class="color-box">
                        <label for="backgroundColor">{{ 'aumico_reports_print_highlight_color_1' | i18next }}</label>
                        <input
                            type="color"
                            [formControl]="form.get('styleOptions')['controls']['backgroundColor']"
                            name="backgroundColor"
                        />
                    </span>
                    <span class="color-box">
                        <label for="backgroundColorPY">{{ 'aumico_reports_print_highlight_color_2' | i18next }}</label>
                        <input
                            type="color"
                            [formControl]="form.get('styleOptions')['controls']['backgroundColorPY']"
                            name="backgroundColorPY"
                        />
                    </span>
                    <span class="color-box">
                        <label for="titleColor">{{ 'aumico_reports_print_title_color' | i18next }}</label>
                        <input
                            type="color"
                            [formControl]="form.get('styleOptions')['controls']['titleColor']"
                            name="titleColor"
                        />
                    </span>
                    <span class="color-box">
                        <label for="tableHeaderColor">{{ 'aumico_reports_print_table_header_color' | i18next }}</label>
                        <input
                            type="color"
                            [formControl]="form.get('styleOptions')['controls']['tableHeaderColor']"
                            name="tableHeaderColor"
                        />
                    </span>

                    <span class="color-box">
                        <label for="tableFooterColor">{{ 'aumico_reports_print_table_footer_color' | i18next }}</label>
                        <input
                            type="color"
                            [formControl]="form.get('styleOptions')['controls']['tableFooterColor']"
                            name="tableFooterColor"
                        />
                    </span>
                    <ham-button
                        style="align-self: flex-start"
                        variant="white"
                        outline="true"
                        size="xs"
                        (buttonClick)="onResetColors()"
                        >{{ 'aumico_reports_print_color_reset_to_default_button' | i18next }}</ham-button
                    >
                </div>
            </div>
        </ham-accordion-item>
    </ham-accordion>
</form>
